import React, { useRef } from 'react'
import ReactPaginate from 'react-paginate'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronRight,
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons'

import S from './styled'
import { SortUp, SortDown, RefreshIcon } from '../icons'

import { Loading } from '../'

const groupItems = (items, groupItemsBy, groupNameField) => {

  const groups = {}
  items.forEach(item => {
    if(!groups[item[groupItemsBy]]) {
      groups[item[groupItemsBy]] = {
        title: item[groupNameField],
        items: [item],
      }
    } else {
      groups[item[groupItemsBy]].items.push(item)
    }
  })

  return Reflect.ownKeys(groups).reduce((acc, key) => {
    return [...acc, { _group: key, title: groups[key].title }, ...groups[key].items]
  }, [])
}

const Sorter = ({ sortType, field, circularSort }) => (
  <S.Sorter>
    <S.SortIcon direction={circularSort ? 'circular' : sortType}>
      { circularSort ? <RefreshIcon />
        : sortType === 'asc' ? <SortUp/> : <SortDown/>}
    </S.SortIcon>
  </S.Sorter>
)

const getNext = (sortType, items) => items.indexOf(sortType) + 1 === items.length ? items[0] : items[items.indexOf(sortType) + 1]

const Table = ({
  columns, rows, noHeader, noAbsolute, getKey, groupItemsBy, groupNameField, sortBy, sortType, onSort,
  fillContainer, pagination, onPageChange, isLoading,
}) => {
  const contanerRef = useRef(null)
  const pageHandler = React.useCallback(event => {
    onPageChange && onPageChange(event)
    if(contanerRef && contanerRef.current) {
      contanerRef.current.scrollTop = 0
    }
  }, [onPageChange])

  return (
    <S.TableWrapper>
      <S.TableContainer ref={contanerRef}>
        <div>
          <S.Table noAbsolute className={fillContainer ? 'fillContainer' : ''}>
            {
              !noHeader && (
                <S.TableHead>
                  <S.TableRow>
                    {
                      columns.map(column => (
                        <S.HeaderCell
                          key={column.name}
                          className={column.sorted ? 'sorted' : ''}
                          onClick={column.sorted ? () => onSort({
                            sortType: column.circularSort ? getNext(sortType, column.circularSort ) : sortType === 'asc' ? 'desc' : 'asc',
                            sortBy: column.sortedFieldName,
                          }) : null}
                        >
                          {column.name}
                          {column.sorted && column.sortedFieldName === sortBy ? (
                            <Sorter {...{ onSort, field: column.sortedFieldName, sortType, circularSort: column.circularSort  }}/>
                          ) : null}
                        </S.HeaderCell>
                      ))
                    }
                  </S.TableRow>
                </S.TableHead>
              )
            }
            <S.TableBody>
              {
                (groupItemsBy ? groupItems(rows, groupItemsBy, groupNameField) : rows).map((row, rowIndex) =>
                  row._group ? (
                    <S.TableRow key={`group_${row._group}`}>
                      <S.Group colSpan={columns.length - 2 }>{row.title}:</S.Group>
                    </S.TableRow>
                  ) :
                    (
                      <S.TableRow key={getKey ? getKey(row, rowIndex) : `${row.id}`}>
                        {
                          columns.map((column, index) => (
                            <S.TableCell key={getKey ? getKey(row, index) : `${row.id}_${index}`} style={column.style}>
                              <S.TableCellContent
                                style={column.contentStyle}
                                noPadding={column.noPadding}
                                center={column.center}
                              >
                                {column.value(row)}
                              </S.TableCellContent>
                            </S.TableCell>
                          ))
                        }
                      </S.TableRow>
                    ),
                )
              }
            </S.TableBody>
          </S.Table>
        </div>
      </S.TableContainer>
      {
        pagination && Math.ceil(pagination.total / pagination.limit) > 1 && (
          <S.Pagination>
            <ReactPaginate
              forcePage={pagination.page}
              initialPage={pagination.page}
              pageCount={Math.ceil(pagination.total / pagination.limit)}
              onPageChange={pageHandler}
              pageRangeDisplayed={8} marginPagesDisplayed={4}
              nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
              previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
            />
          </S.Pagination>
        )
      }
      {
        isLoading && <Loading overlay container/>
      }
    </S.TableWrapper>
  )
}
export default Table
